import React from 'react';
import { shareIcons, icons, playIcon } from '../../shared/styles/icons';
import { styles } from './styles/VideoPlaylistItemStyles';
import { StyleSheet, css } from 'aphrodite/no-important';

class VideoPlaylistItem extends React.Component {
    constructor(props) {
        super(props);    

        this.state = { videoHover: false}
        this.post = this.props.post || {};
        this.toggleVideoHover = this.toggleVideoHover.bind(this);
        this.updateCurrentPost = (e) => {
            e.preventDefault();
            //set active state 
            if(this.props.setActiveState) {
                this.props.setActiveState(this.props.index + 1);
            }
            this.props.onClick(this.post);
        }
    }

    /**
     * toggles video hover state
     */
    toggleVideoHover(){
		this.setState({videoHover: !this.state.videoHover});
	}


    componentDidMount(){ 

    }

    componentDidUpdate(){

    }

    render(){
        let post = this.post;
        let titleStyles = [styles.thumbTitle];
        let nowPlayingStyles = [icons.icNowPlaying];
        let thumbOverlayStyles = [styles.thumbOverlay];

        let isActive = this.props.index === this.props.activeItem;

        let playBtnStyles = [playIcon.icPlayTiny, styles.zIndexOne];

        if (this.state.videoHover) {
			playBtnStyles.push(playIcon.icPlayHover);
		}

        return (
            <a href={this.post.videoUrl} className={css(styles.videoTplCont) + ' more-thumb-link'} onClick={this.updateCurrentPost} data-release-url={post.releaseUrl}
            onMouseEnter={this.toggleVideoHover} onMouseLeave={this.toggleVideoHover}>
                <div className={css(styles.videoThumb)}>
                    <div className={css(styles.imgOverlay)}>
                        <img src={post.thumb} className={css(styles.imgThumb)}/>
                        <span className={css(styles.playCont)}>
                            <span className={css(styles.playIcon) + ' play-icon_vc'}>
                                <span className={css(playBtnStyles) + ' play-dtn_vc'}></span>
                                {post.duration &&
                                    <span className={css(styles.durationContainer)}>
                                        <span className={css(styles.duration)}>{post.duration}</span>
                                    </span>
                                }
                            </span>
                        </span>
                    </div>
                </div>
                <div className={css(styles.meta)}>
                    { isActive && <span className={css(icons.icUpNext)}> </span> }
                    <span className={css(titleStyles)}> {post.title} </span>
                </div>
            </a>    
        )
    }

}

export default VideoPlaylistItem;
